import React from "react";

const Skills = () => {
  const skillsData = {
    frontend: [
      { name: "JavaScript", level: 95 },
      { name: "React", level: 90 },
      { name: "TypeScript", level: 85 },
      { name: "HTML5", level: 95 },
      { name: "CSS3", level: 90 }
    ],
    backend: [
      { name: "Node.js", level: 90 },
      { name: "Python", level: 85 },
      { name: "REST APIs", level: 90 },
      { name: "GraphQL", level: 80 },
      { name: "Django", level: 70 },
    ],
    devops: [
      { name: "Git", level: 95 },
      { name: "Docker", level: 85 },
      { name: "AWS", level: 75 },
      { name: "PostgreSQL", level: 85 },
      { name: "MongoDB", level: 80 }
    ]
  };

  return (
    <div className="w-full px-6 py-12 bg-gray-900">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        <SkillCategory
          title="Frontend"
          skills={skillsData.frontend}
          iconColor="text-blue-400"
          barColor="bg-blue-500"
        />
        <SkillCategory
          title="Backend"
          skills={skillsData.backend}
          iconColor="text-purple-400"
          barColor="bg-purple-500"
        />
        <SkillCategory
          title="DevOps"
          skills={skillsData.devops}
          iconColor="text-green-400"
          barColor="bg-green-500"
        />
      </div>
    </div>
  );
};

const SkillCategory = ({ title, skills, iconColor, barColor }) => (
  <div className="bg-gray-800 p-6 rounded-xl shadow-lg">
    <h2 className={`text-xl font-semibold mb-6 ${iconColor}`}>
      {title}
    </h2>
    <ul className="space-y-4">
      {skills.map((skill, index) => (
        <li key={index}>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-gray-300">{skill.name}</span>
            <span className="text-gray-400">{skill.level}%</span>
          </div>
          <div className="w-full bg-gray-700 rounded-full h-2">
            <div
              className={`h-full rounded-full ${barColor}`}
              style={{ width: `${skill.level}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  </div>
);

export default Skills;